import { render, staticRenderFns } from "./CreateSubregionManagerControl.vue?vue&type=template&id=7225d211&"
import script from "./CreateSubregionManagerControl.vue?vue&type=script&lang=js&"
export * from "./CreateSubregionManagerControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports